import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LoadingController, ModalController, ToastController } from "@ionic/angular";
import { ValidationVersion } from "src/app/processes/_interfaces/validation-version.interface";
import { BaseClass } from "src/app/shared/classes/base";
import { SelectItem } from "src/app/shared/classes/SelectItem";
import { ProcessConfigModalComponent } from "src/app/shared/components/process-config-modal/process-config-modal.component";
import { GlobalizationConfig } from "src/app/shared/interfaces/globalization-config.interface";
import { QuestionGroup, QuestionTypeEnum } from "src/app/shared/interfaces/process-config.interface";
import { CalibrationTypeEnum, ProcessTypeEnum } from "src/app/shared/interfaces/process.interface";
import { AttributeTypeEnum, FilterItem } from "src/app/shared/modals/filters/models/filter-models";
import { ConfigService } from "src/app/shared/services/multi-clients/config.service";
import { TranslationService } from "src/app/shared/services/translation.service";
import * as uuid from "uuid";
import { GoalTypeEnum } from "../../shared/enums/GoalTypeEnum";
import { Version } from "../_interfaces/version.interface";
import { ProcessesService } from "../processes.service";
import { ReviewsConfigService } from "src/app/parameters/reviews-config/reviews-config.service";

@Component({
    selector: "app-manage-version",
    templateUrl: "./manage-version.page.html",
    styleUrls: ["./manage-version.page.scss"],
})
export class ManageVersionPage extends BaseClass implements OnInit {
    public ProcessType = ProcessTypeEnum;
    public _processType: ProcessTypeEnum;
    public processesWithValidations = [ProcessTypeEnum.GoalInputs, ProcessTypeEnum.GoalsReview, ProcessTypeEnum.ThreeSixtyEvaluation, ProcessTypeEnum.FinalFeedback];
    public nonConfigurableQuestionProcesses = [this.ProcessType.HeadEvaluation, this.ProcessType.GoalsReview, this.ProcessType.EvaluationCalibration];

    public userAttributesOnProcessAllowed: boolean;
    public setPossibleValuesEndYearAsENTranslate: boolean;

    public version: Version = null;
    public selfEvaluationVersions: Version[];
    public goalsInputValidationsVersions: ValidationVersion[];
    public goalsReviewValidationsVersions: ValidationVersion[];
    public threeSixtyValidationsVersions: ValidationVersion[];
    public threeSixtySelectionVersions: ValidationVersion[];
    public finalFeedbackValidationsVersions: ValidationVersion[];
    public groupsSelectItems: SelectItem[] = [];
    public managerGroupsSelectItems: SelectItem[] = [];
    public selectedLanguage: "pt-BR" | "en-US" | "es-ES" = "pt-BR";
    public canShowFlags = false;
    public userAttributesOnProcessAllowedFlag: boolean = false;
    public managerQuestionGroupsSelected: boolean = false;
    public calibrationTypeList: Array<{ Key: CalibrationTypeEnum; TranslationKey: string }> = [];
    public attributes: any;

    private readonly _versionId: number; constructor(
        private _reviewsConfigService: ReviewsConfigService,
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _loadingController: LoadingController,
        private _activatedRoute: ActivatedRoute,
        private _processesService: ProcessesService,
        private _router: Router,
        private _configService: ConfigService,
        private _cdr: ChangeDetectorRef
    ) {
        super(_toastController, _translationService);
        this._processType = parseInt(this._activatedRoute.snapshot.paramMap.get("processType"), 10);
        this._versionId = parseInt(this._activatedRoute.snapshot.paramMap.get("versionId"), 10);
        this.userAttributesOnProcessAllowed = this._configService.settings.features.userAttributesOnProcessAllowed;
        this.setPossibleValuesEndYearAsENTranslate = this._configService.settings.features.setPossibleValuesEndYearAsENTranslate;
        this.setPossibleValuesEndYearAsENTranslate = this._configService.settings.features.setPossibleValuesEndYearAsENTranslate;

        this.calibrationTypeList = [
            { Key: CalibrationTypeEnum.ForcedCurve, TranslationKey: 'calibrationType.forcedCurve' },
            { Key: CalibrationTypeEnum.Matrix, TranslationKey: 'calibrationType.matrix' },
            { Key: CalibrationTypeEnum.Both, TranslationKey: 'calibrationType.both' },
        ];
    }

    ngOnInit() {
        this.getAttributes();

        console.log('DEBUG: ngOnInit called');
    } async ionViewWillEnter() {
        console.log('DEBUG: ionViewWillEnter started, _versionId:', this._versionId);
        if (this._versionId > 0) {
            await this._loadVersion(this._versionId);
        } else {
            console.log('DEBUG: Creating new version with type:', this._processType);
            this.version = new Version(this._processType);
            console.log('DEBUG: Version created:', this.version);
            console.log('DEBUG: globalizationConfig:', this.version.globalizationConfig);
            this.canShowFlags = [
                ProcessTypeEnum.FreeEvaluationMidYear,
                ProcessTypeEnum.FreeEvaluationEndYear,
                ProcessTypeEnum.ThreeSixtyEvaluation,
                ProcessTypeEnum.ManagerEvaluation,
                ProcessTypeEnum.FinalFeedback,
            ].includes(this.version.type);
            this._loadQuestionTypeConfigs();
            if (this.processesWithValidations.includes(this._processType)) {
                this._loadValidationVersions();
            }
            if (this._processType === ProcessTypeEnum.ManagerEvaluation) {
                await this._loadSelfEvaluationVersions();
            } else if (this._processType === ProcessTypeEnum.GoalInputs) {
                await this._loadGoalInputDefaultQuestions();
            }
        }
        console.log('DEBUG: ionViewWillEnter finished, version:', this.version);
        console.log('DEBUG: About to call _cdr.detectChanges() in ionViewWillEnter');
        this._cdr.detectChanges();
    }

    private _loadSelfEvaluationVersions() {
        this._processesService.getSelfEvaluationVersions().subscribe(
            (response) => {
                this.selfEvaluationVersions = response.data.map((x) => this._setValuesAmount(x));
            },
            (error) => {
                this.notifyError(error);
            },
        );
    }

    public getAttributes() {
        this._reviewsConfigService.getAttributes().subscribe((response) => {
            if (response && response.data && Array.isArray(response.data[18])) {
                this.attributes = response.data[18];
            } else {
                this.attributes = [];
            }
            console.log('DEBUG: Attributes loaded:', this.attributes);
        });
    }




    private _compareObjects(obj1, obj2) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (const key of keys1) {
            const val1 = obj1[key];
            const val2 = obj2[key];
            const areObjects = typeof val1 === "object" && typeof val2 === "object";
            if ((areObjects && !this._compareObjects(val1, val2)) || (!areObjects && val1 !== val2)) {
                return false;
            }
        }

        return true;
    }

    private _loadValidationVersions(validateVersion: ValidationVersion = null) {
        this._processesService.getValidationVersions().subscribe(
            (response) => {
                if (Array.isArray(response)) {
                    this.goalsInputValidationsVersions = response.filter((d) => d.type == ProcessTypeEnum.GoalInputValidation).map((x) => this._setValuesAmount(x));
                    this.goalsReviewValidationsVersions = response.filter((d) => d.type == ProcessTypeEnum.GoalsReviewValidation).map((x) => this._setValuesAmount(x));
                    this.threeSixtyValidationsVersions = response.filter((d) => d.type == ProcessTypeEnum.ThreeSixtyEvaluatorsValidation).map((x) => this._setValuesAmount(x));
                    this.finalFeedbackValidationsVersions = response.filter((d) => d.type == ProcessTypeEnum.FinalFeedbackValidation).map((x) => this._setValuesAmount(x));
                } else if (response.data && Array.isArray(response.data)) {
                    this.goalsInputValidationsVersions = response.data.filter((d) => d.type == ProcessTypeEnum.GoalInputValidation).map((x) => this._setValuesAmount(x));
                    this.goalsReviewValidationsVersions = response.data.filter((d) => d.type == ProcessTypeEnum.GoalsReviewValidation).map((x) => this._setValuesAmount(x));
                    this.threeSixtyValidationsVersions = response.data.filter((d) => d.type == ProcessTypeEnum.ThreeSixtyEvaluatorsValidation).map((x) => this._setValuesAmount(x));
                    this.finalFeedbackValidationsVersions = response.data.filter((d) => d.type == ProcessTypeEnum.FinalFeedbackValidation).map((x) => this._setValuesAmount(x));
                }
                const newVersion: ValidationVersion = {
                    globalizationConfig: new GlobalizationConfig(),
                    type: null,
                    versionName: "manageVersion.newValidationVersion",
                    id: 0,
                };
                this.goalsInputValidationsVersions.splice(0, 0, newVersion);
                this.goalsReviewValidationsVersions.splice(0, 0, newVersion);
                this.threeSixtyValidationsVersions.splice(0, 0, newVersion);
                this.finalFeedbackValidationsVersions.splice(0, 0, newVersion);

                if (validateVersion) {
                    let validateVersions;
                    switch (this.version.type) {
                        case ProcessTypeEnum.GoalInputs:
                            validateVersions = this.goalsInputValidationsVersions;
                            break;
                        case ProcessTypeEnum.GoalsReview:
                            validateVersions = this.goalsReviewValidationsVersions;
                            break;
                        case ProcessTypeEnum.FinalFeedback:
                            validateVersions = this.finalFeedbackValidationsVersions;
                            break;
                        default:
                            validateVersions = this.threeSixtyValidationsVersions;
                            break;
                    }
                    let selectedValidateVersion = validateVersions.find(
                        (vVersion) =>
                            vVersion.versionName == validateVersion.versionName &&
                            vVersion.globalizationConfig &&
                            validateVersion.globalizationConfig &&
                            vVersion.globalizationConfig[this.selectedLanguage].title == validateVersion.globalizationConfig[this.selectedLanguage].title &&
                            vVersion.globalizationConfig[this.selectedLanguage].instructions == validateVersion.globalizationConfig[this.selectedLanguage].instructions &&
                            vVersion.globalizationConfig[this.selectedLanguage].instructions_External ==
                            validateVersion.globalizationConfig[this.selectedLanguage].instructions_External &&
                            vVersion.globalizationConfig[this.selectedLanguage].placeholder == validateVersion.globalizationConfig[this.selectedLanguage].placeholder,
                    );
                    this.version.validationProcessId = selectedValidateVersion !== null ? selectedValidateVersion.id : null;
                }
            },
            (error) => {
                this.notifyError(error);
            },
        );
    }

    private _loadSelectionVersions(selectionVersion: ValidationVersion = null) {
        this._processesService.getSelectionVersions().subscribe(
            (response) => {
                if (Array.isArray(response)) {
                    this.threeSixtySelectionVersions = response.filter((d) => d.type == ProcessTypeEnum.ThreeSixtyEvaluatorsSelection).map((x) => this._setValuesAmount(x));
                } else if (response.data && Array.isArray(response.data)) {
                    this.threeSixtySelectionVersions = response.data.filter((d) => d.type == ProcessTypeEnum.ThreeSixtyEvaluatorsSelection).map((x) => this._setValuesAmount(x));
                }
                const newVersion: ValidationVersion = {
                    globalizationConfig: new GlobalizationConfig(),
                    type: null,
                    versionName: "manageVersion.newSelectionVersion",
                    id: 0,
                };
                this.threeSixtySelectionVersions.splice(0, 0, newVersion);

                if (selectionVersion) {
                    let selectedSelectionVersion = this.threeSixtySelectionVersions.find(
                        (vVersion) =>
                            vVersion.versionName == selectionVersion.versionName &&
                            vVersion.globalizationConfig &&
                            selectionVersion.globalizationConfig &&
                            vVersion.globalizationConfig[this.selectedLanguage].title == selectionVersion.globalizationConfig[this.selectedLanguage].title &&
                            vVersion.globalizationConfig[this.selectedLanguage].instructions == selectionVersion.globalizationConfig[this.selectedLanguage].instructions &&
                            vVersion.globalizationConfig[this.selectedLanguage].instructions_External ==
                            selectionVersion.globalizationConfig[this.selectedLanguage].instructions_External &&
                            vVersion.globalizationConfig[this.selectedLanguage].placeholder == selectionVersion.globalizationConfig[this.selectedLanguage].placeholder,
                    );
                    this.version.selectionProcessId = selectedSelectionVersion !== null ? selectedSelectionVersion.id : null;
                }
            },
            (error) => {
                this.notifyError(error);
            },
        );
    }

    private _loadGoalInputDefaultQuestions() {
        this._processesService.getGoalInputDefaultQuestions().subscribe(
            (response) => {
                this.version.questions.push(...response.data.map((x) => this._setValuesAmount(x)));
            },
            (error) => {
                this.notifyError(error);
            },
        );
    }

    public goBack(): void {
        this._router.navigate(["processes"]);
    }

    public changeSelectedLanguage(language: "pt-BR" | "en-US" | "es-ES"): void {
        this.selectedLanguage = language;
    }

    public async saveProcess(version: Version): Promise<void> {
        if (this._validateQuestions(version)) {
            const loading = await this._loadingController.create();
            await loading.present();
            if (this.setPossibleValuesEndYearAsENTranslate && [ProcessTypeEnum.FreeEvaluationEndYear].includes(version.type)) {
                version.questionGroups.map((qg) => {
                    qg.questions.map((q) => {
                        if (!q.type) q.typeConfig.possibleValues = q.typeConfig.possibleValuesGlobalized["en-US"];
                    });
                });
            }
            if (version.type != ProcessTypeEnum.GoalsReview) {
                let questionWithAttributeForGlobalizationConfig =
                    (version.questions ?? []).filter(q =>
                        Array.isArray(q.attributesQuestionConfig) && q.attributesQuestionConfig.length > 0
                    );
                if (questionWithAttributeForGlobalizationConfig && questionWithAttributeForGlobalizationConfig.length > 0) {
                    let isAllAnswered = questionWithAttributeForGlobalizationConfig.every(q => {
                        return q.attributesQuestionConfig.every(a => {
                            return !!a.attributeId
                                && !!a.questionId
                                && a.globalizationConfig['en-US'] && !!a.globalizationConfig['en-US'].title
                                && !!a.globalizationConfig['en-US'].instructions
                                && a.globalizationConfig['es-ES'] && !!a.globalizationConfig['es-ES'].title
                                && !!a.globalizationConfig['es-ES'].instructions
                                && a.globalizationConfig['pt-BR'] && !!a.globalizationConfig['pt-BR'].title
                                && !!a.globalizationConfig['pt-BR'].instructions;
                        });
                    });

                    if (!isAllAnswered) {
                        this.notify(this._translationService.getTranslation("manageVersion.questionWithAttributeForGlobalizationConfig"), "danger");
                        await loading.dismiss();
                        return;
                    }
                }
            }

            if (!this.nonConfigurableQuestionProcesses.includes(version.type)) {
                let questionWithAttributeForGlobalizationConfig = version.questions.filter(q => Array.isArray(q.attributesQuestionConfig) && q.attributesQuestionConfig.length > 0);
                if (questionWithAttributeForGlobalizationConfig && questionWithAttributeForGlobalizationConfig.length > 0) {
                    let isAllAnswered = questionWithAttributeForGlobalizationConfig.every(q => {
                        if (Array.isArray(q.attributesQuestionConfig)) {
                            return q.attributesQuestionConfig.every(a => {
                                return !!a.attributeId
                                    && !!a.questionId
                                    && a.globalizationConfig['en-US'] && !!a.globalizationConfig['en-US'].title
                                    && !!a.globalizationConfig['en-US'].instructions
                                    && a.globalizationConfig['es-ES'] && !!a.globalizationConfig['es-ES'].title
                                    && !!a.globalizationConfig['es-ES'].instructions
                                    && a.globalizationConfig['pt-BR'] && !!a.globalizationConfig['pt-BR'].title
                                    && !!a.globalizationConfig['pt-BR'].instructions;
                            });
                        }
                        return false;
                    });

                    if (!isAllAnswered) {
                        this.notify(this._translationService.getTranslation("manageVersion.questionWithAttributeForGlobalizationConfig"), "danger");
                        await loading.dismiss();
                        return;
                    }
                }
            }

            version.id ? this._updateProcess(version, loading) : this._addProcess(version, loading);
        }
    }

    private _validateQuestions(version: Version): boolean {
        const validationError = this._processesService.validateQuestions(version);
        if (validationError) {
            let errorMessage = this._translationService.getTranslation(validationError[0] as string);
            errorMessage =
                errorMessage + (validationError.length > 2 ? " - Group #" + validationError[2] : "") + (validationError.length > 1 ? " - Question #" + validationError[1] : "");
            this.notify(errorMessage, "danger");
            return false;
        }
        return true;
    }

    private _addProcess(version: Version, loading: HTMLIonLoadingElement): void {
        this._processesService.addProcess(version).subscribe(
            () => {
                loading.dismiss();
                this.notifySuccess("generic.saveSuccess");
                this._router.navigate(["processes"]);
            },
            (error) => {
                loading.dismiss();
                this.notifyError(error);
            },
        );
    }

    private _updateProcess(version: Version, loading: HTMLIonLoadingElement): void {
        this._processesService.updateProcess(version).subscribe(
            (resp) => {
                loading.dismiss();
                if (resp.data && resp.data.warning) {
                    this.notify(this._translationService.getTranslation(resp.data.warning), "warning");
                } else {
                    this.notifySuccess("generic.saveSuccess");
                    this._router.navigate(["processes"]);
                }
            },
            (error) => {
                loading.dismiss();
                if (error.error && error.error.errors && error.error.errors.length > 0) {
                    let err = error.error.errors[0].split("$");
                    err[1] = this._translationService.getTranslation(err[1]);
                    let errorMessage = err[1] + " " + err[0];
                    this.notify(errorMessage, "danger");
                } else this.notifyError(error);
            },
        );
    }

    public getQuestionGroupsTotalQuestions(groups: QuestionGroup[]) {
        let count = 0;
        for (const g of groups) {
            count += g.questions.length;
        }
        return count;
    } private async _loadVersion(processId: number): Promise<void> {
        console.log('DEBUG: _loadVersion started with processId:', processId);
        const loading = await this._loadingController.create();
        loading.present();
        this._processesService.getProcessById(processId).subscribe(
            (response) => {
                console.log('DEBUG: _loadVersion response:', response);
                this.version = this._setValuesAmount(response.data);
                console.log('DEBUG: version after _setValuesAmount:', this.version);
                console.log('DEBUG: globalizationConfig after load:', this.version.globalizationConfig);
                this.version.goalType = response.data.goalType === 1 ? GoalTypeEnum.Consent : GoalTypeEnum.Input;
                this.version.anonymousReport = response.data.anonymousReport;
                this.version.hrOnlyReport = response.data.hrOnlyReport;
                this.version.skipTwoPlusTwoCoachingEvaluation = response.data.skipTwoPlusTwoCoachingEvaluation;
                this.userAttributesOnProcessAllowedFlag = this.version.userAttributesAllowed && this.version.userAttributesAllowed.length > 0;

                this.version.userAttributesItemAllowed.forEach((a) => {
                    a.typeName = AttributeTypeEnum.Dictionary[a.type].name;
                });
                this.version.enableValuationLimit = response.data.enableValuationLimit;
                this.version.threeSixtyEvaluationLimit = response.data.threeSixtyEvaluationLimit;
                this.version.threeSixtyEvaluationTimespanInHours = response.data.threeSixtyEvaluationTimespanInHours;

                if (this.version.questions) this._initializeQuestions();

                if (this.version.questionGroups && this.version.questionGroups.length > 0) this.initializeQuestionGroups();

                if (this.version.managerQuestionGroups && this.version.managerQuestionGroups.length > 0) this.initializeQuestionGroups(true);

                this.buildGroupsSelectItems();
                this.canShowFlags = [
                    ProcessTypeEnum.FreeEvaluationMidYear,
                    ProcessTypeEnum.FreeEvaluationEndYear,
                    ProcessTypeEnum.ThreeSixtyEvaluation,
                    ProcessTypeEnum.ManagerEvaluation,
                    ProcessTypeEnum.FinalFeedback,].includes(this.version.type);
                console.log('DEBUG: About to call _cdr.detectChanges()');
                this._cdr.detectChanges();
                loading.dismiss();
            },
            (error) => {
                this.notifyError(error);
                loading.dismiss();
            },
        );
        if (this.processesWithValidations.includes(this._processType)) {
            this._loadValidationVersions();
        }
        if (this._processType === ProcessTypeEnum.ThreeSixtyEvaluation) {
            this._loadSelectionVersions();
        }
    }

    private _loadQuestionTypeConfigs() {
        this._processesService.getQuestionTypeConfigs().subscribe(
            (response) => {
                this.version.questionTypeConfigs = response.data;
            },
            (error) => {
                this.notifyError(error);
            },
        );
    }

    private _initializeQuestions() {
        for (const q of this.version.questions) {
            q.guid = uuid.v4();
        }
    }

    public initializeQuestionGroups(manager = false) {
        this.version.questions = [];
        let groups = manager ? this.version.managerQuestionGroups : this.version.questionGroups;
        if (!groups) return;

        groups = groups.sort((a, b) => a.order - b.order);
        for (const g of groups) {
            g.guid = uuid.v4();
            if (g.questions && g.questions.length > 0) {
                for (let i = 0; i < g.questions.length; i++) {
                    g.questions[i].groupGuid = g.guid;
                    g.questions[i].order = i + 1;
                    g.questions[i].guid = uuid.v4();
                }
            }
        }
    }

    public selectManagerQuestionGroups() {
        this.managerQuestionGroupsSelected = true;
    }

    public selectMainQuestionGroups() {
        this.managerQuestionGroupsSelected = false;
    }

    public buildGroupsSelectItems() {
        if (this.version.questionGroups && this.version.questionGroups.length > 0)
            this.groupsSelectItems = this.version.questionGroups.map((x) => new SelectItem(x.guid.toString(), x.globalizationConfig[this.selectedLanguage].title));
        if (this.version.managerQuestionGroups && this.version.managerQuestionGroups.length > 0)
            this.managerGroupsSelectItems = this.version.managerQuestionGroups.map((x) => new SelectItem(x.guid.toString(), x.globalizationConfig[this.selectedLanguage].title));
    }

    private _setValuesAmount(version: Version): Version {
        if (version.questions) {
            const rangeQuestions = version.questions.filter((q) => q.typeConfig.type === QuestionTypeEnum.Slider);
            if (rangeQuestions.length > 0) {
                rangeQuestions.forEach((q) => (q.typeConfig.valuesAmount = q.typeConfig.possibleValues.length));
            }
        }

        if (version.questionGroups && version.questionGroups.length > 0) {
            version.questionGroups.forEach((g) => {
                const rangeQuestions = g.questions.filter((q) => q.typeConfig.type === QuestionTypeEnum.Slider);
                if (rangeQuestions.length > 0) {
                    rangeQuestions.forEach((q) => (q.typeConfig.valuesAmount = q.typeConfig.possibleValues.length));
                }
            });
        }

        if (version.managerQuestionGroups && version.managerQuestionGroups.length > 0) {
            version.managerQuestionGroups.forEach((g) => {
                const rangeQuestions = g.questions.filter((q) => q.typeConfig.type === QuestionTypeEnum.Slider);
                if (rangeQuestions.length > 0) {
                    rangeQuestions.forEach((q) => (q.typeConfig.valuesAmount = q.typeConfig.possibleValues.length));
                }
            });
        }

        return version;
    }

    public setValidationId(event) {
        this.version.validationProcessId = event.target.value;
    }
    public setSelectionId(event) {
        this.version.selectionProcessId = event.target.value;
    }
    public setHeadAttribute(event) {
        console.log('DEBUG: setHeadAttribute called with value:', event.target.value);
        this.version.headAttribute = event.target.value;
    }
    public async openProcessConfigModal(selectionProcess: boolean = false) {
        if (this.processesWithValidations.includes(this.version.type)) {
            let validationProcessVersions = [
                ...this.goalsInputValidationsVersions,
                ...this.goalsReviewValidationsVersions,
                ...this.threeSixtyValidationsVersions,
                ...this.finalFeedbackValidationsVersions,
            ];

            const processVersion =
                validationProcessVersions && Array.isArray(validationProcessVersions)
                    ? selectionProcess
                        ? this.threeSixtySelectionVersions.find((d) => d.id == this.version.selectionProcessId)
                        : validationProcessVersions.find((d) => d.id == this.version.validationProcessId)
                    : null;

            switch (this.version.type) {
                case ProcessTypeEnum.GoalInputs:
                    processVersion.type = ProcessTypeEnum.GoalInputValidation;
                    break;
                case ProcessTypeEnum.GoalsReview:
                    processVersion.type = ProcessTypeEnum.GoalsReviewValidation;
                    break;
                case ProcessTypeEnum.ThreeSixtyEvaluation:
                    processVersion.type = selectionProcess ? ProcessTypeEnum.ThreeSixtyEvaluatorsSelection : ProcessTypeEnum.ThreeSixtyEvaluatorsValidation;
                    break;
                case ProcessTypeEnum.FinalFeedback:
                    processVersion.type = ProcessTypeEnum.FinalFeedbackValidation;
                    break;
                default:
                    processVersion.type = ProcessTypeEnum.ThreeSixtyEvaluatorsValidation;
                    break;
            }

            const modal = await this._modalController.create({
                component: ProcessConfigModalComponent,
                cssClass: "bigger-modal",
                componentProps: {
                    language: this.selectedLanguage,
                    versionId: processVersion.id,
                    isSelection: selectionProcess,
                    version: processVersion,
                },
            });
            await modal.present();

            modal.onDidDismiss().then(async (dismissEvent) => {
                if (dismissEvent.data) {
                    if (selectionProcess) this._loadSelectionVersions(processVersion);
                    else this._loadValidationVersions(processVersion);
                }
            });
        }
    }

}
